// src/styles/colors.js
// Paleta base (raw). As cores que mudam entre light/dark (background, surface,
// primary, secondary) são definidas como SEMANTIC TOKENS em theme.js — por isso
// não ficam aqui, para não conflitarem com os tokens.
export const colors = {
    // Marca (referência fixa, para usos pontuais que não dependem do modo)
    brand: {
        neon: '#01E975',      // Neon Green (oficial do manual)
        neonHover: '#00C864', // Neon hover/pressed
        darkGreen: '#001300', // Dark Green
        bege: '#F2EDDA',      // Bege
    },

    // Tons neutros e de contraste
    white: '#FFFFFF',
    beige: '#F2EDDA',
    gray: {
        100: '#E2E8F0',
        200: '#CBD5E0',
        300: '#A0AEC0',
        400: '#718096',
        500: '#4A5568',
        600: '#2D3748',
        700: '#1A202C',
        800: '#171923',
        900: '#0F0F0F',
    },

    transparent: 'transparent',
    current: 'currentColor',
};
